/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

import React from "react";
import { MarkdownContent, Loading } from "@/shared/ui";
import { useTranslation } from "react-i18next";
import PolicyPageLayout from "../service-terms/PolicyPageLayout";
import { useDocumentContent } from "../shared/hooks/useDocumentContent";
import { PageSEO, HreflangTags, BreadcrumbSchema } from "@/shared/seo";

const PrivacyPolicy: React.FC = () => {
  const { t } = useTranslation("@pages/policy");
  const { content, isLoading } = useDocumentContent('privacy-policy', `# ${t("privacyPolicy.title")}\n\nContent coming soon.`);

  if (isLoading) return <Loading mode="section" size="lg" />;

  return (
    <>
      {/* SEO Meta Tags */}
      <PageSEO
        title={t("privacyPolicy.title")}
        description={t("privacyPolicy.description", "Privacy Policy for Housien - Learn how we collect, use, and protect your personal data.")}
        noIndex={false}
      />
      <HreflangTags />
      <BreadcrumbSchema
        items={[
          { name: t("breadcrumb.home"), url: "/" },
          { name: t("privacyPolicy.title"), url: "/privacy/v1" },
        ]}
      />

      <PolicyPageLayout
        title={t("privacyPolicy.title")}
        lastUpdated={t("privacyPolicy.metaLastUpdated")}
        version={t("privacyPolicy.metaVersion")}
        lastUpdatedLabel={t("privacyPolicy.lastUpdated")}
        versionLabel={t("privacyPolicy.version")}
      >
        <MarkdownContent content={content} headingOffset={1} />
      </PolicyPageLayout>
    </>
  );
};

export default PrivacyPolicy;
